import { render, staticRenderFns } from "./ComplaintCause.vue?vue&type=template&id=56edecb6&"
import script from "./ComplaintCause.vue?vue&type=script&lang=js&"
export * from "./ComplaintCause.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintCause.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports